/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Utils from '../utils/utils';
import { PRIVATE_PATH } from '../constants';

const ProtectedManagementCompanySectionRoute = ({ component: Component, ...rest }) => (
	<Route
		{...rest}
		render={() =>
			Utils.isGlobalManagementCompanyAuthorized(
				rest.pathPermission,
				rest.operation,
				rest.globalManagementCompanyPermissions
			) ? (
				<Component {...rest} />
			) : (
				<Redirect to={PRIVATE_PATH.SHIFTS} />
			)
		}
	/>
);

export default ProtectedManagementCompanySectionRoute;
